module.exports = __webpack_public_path__ + "static/media/provider5@3x.7df03537.png";